import { css } from '@emotion/core';

export const searchInputMobileMenuCSS = css`
    max-height: unset;
    border-radius: 0;
    box-shadow: none;
`;

export const searchInputMobileOverlayWidthCSS = css`
    width: 100%;
`;

export const navigationBarSearchMobileSearchBarCSS = ({ colors }) => css`
    height: 3rem;
    background-color: ${colors.neutral99};
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.75rem 1rem;
    border-bottom: 0.0625rem solid ${colors.neutral70};
`;

export const navigationBarSearchMobileSearchInputCSS = css`
    height: 100%;
    padding: 0;

    svg {
        padding: 0.75rem;
        margin: 0;
    }
`;

export const navigationBarSearchMobileCloseButtonCSS = ({ colors }) => css`
    height: 3rem;
    padding: 0.75rem 1rem;
    border: 0;
    background: none;
    font-size: 1rem;
    cursor: pointer;
    border-radius: 0.5rem;

    &:hover {
        background-color: ${colors.whiteBackgroundColorActive};
        border: 0;
    }

    &:focus,
    &:focus-visible {
        background-color: ${colors.whiteBackgroundColorFocus};
        outline: none;
    }
`;
